
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M228.666 83.01l152 264c3.839 6.667-.973 14.99-8.666 14.99H68c-7.693 0-12.505-8.323-8.666-14.99l152-264c3.846-6.68 13.486-6.68 17.332 0zM220 88L68 352h304L220 88zm0 194c12.703 0 23 10.297 23 23s-10.297 23-23 23-23-10.297-23-23 10.297-23 23-23zm0 10c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm4.287-121c8.284 0 15 6.716 15 15a15 15 0 01-.036 1.032l-4.62 67c-.543 7.865-7.081 13.968-14.965 13.968h-1.332c-7.884 0-14.422-6.103-14.964-13.968l-4.621-67c-.57-8.265 5.668-15.426 13.932-15.996a15 15 0 01.688-.032l.344-.004h10.574zm0 10h-10.574l-.172.003-.172.009a5 5 0 00-4.644 5.332l4.62 67a5 5 0 004.99 4.656h1.33a5 5 0 004.99-4.656l4.62-67a5 5 0 00-4.988-5.344z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    